import { useGame } from "../../app/GameProvider.js";
import { getMapEvent } from "../../content/events.js";
import { getCard } from "../../content/lookups.js";
import { cardKindLabel } from "../../components/cardFrame.js";
import { ChoiceHead } from "../shared/ChoiceHead.js";

export function EventScreen() {
  const { state, dispatch } = useGame();
  const activeEvent = state.activeEvent;
  if (!state.run || !activeEvent) return null;

  const event = getMapEvent(activeEvent.eventId);

  return (
    <section className="screen screen-event">
      <ChoiceHead kicker="EVENT" title="はてなマス" />
      <div className="event-card is-offer">
        <div className="event-mark" aria-hidden="true">?</div>
        <p className="event-polarity">OFFER</p>
        <h2>{event.name}</h2>
        <p className="event-flavor">{event.flavor}</p>
        <div className="event-effect" aria-label={`受け入れた場合：${activeEvent.effectText.replaceAll("\n", "、")}`}>
          <small>受け入れた場合</small>
          {activeEvent.effects.map((effect, index) => {
            if (effect.kind !== "addCard") {
              return <p key={`${effect.kind}-${index}`}>{activeEvent.effectText.split("\n")[index]}</p>;
            }
            const card = getCard(effect.cardId);
            return (
              <div className="event-gained-card" key={`${effect.cardId}-${index}`}>
                <p>「{card?.name ?? effect.cardId}」を獲得</p>
                {card && <span>{cardKindLabel(card)}：{card.text}</span>}
              </div>
            );
          })}
        </div>
      </div>
      <footer className="event-actions">
        <div className="row">
          <button type="button" className="btn" onClick={() => dispatch({ type: "DECLINE_EVENT" })}>
            今回は見送る
          </button>
          <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "ACCEPT_EVENT" })}>
            受け入れる
          </button>
        </div>
      </footer>
    </section>
  );
}
